<template>
    <b-container>
        <b-row class="vh-100 text-center" align-v="center">
            <b-col cols="12">
                <img src="img/icons/android-chrome-512x512.png" height="150px" class="mb-5"/> <br />
                {{ $t('pwaPromotion') }} <br />
                <b-button variant="primary" @click="install" class="mt-5" size="lg">{{ $t('install') }}</b-button>
            </b-col>
        </b-row>
    </b-container>
</template>
  
  <script>
  
  export default {
    name: 'PwaInstall', 
    data: function() {
      return {
        installPrompt: null
      }
    },
  
    methods: {
      install() {
        if (this.installPrompt) this.installPrompt.prompt();
      }
    },  
  
    created() {
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevents the default mini-infobar or install dialog from appearing on mobile
        e.preventDefault();
        // Save the event because you'll need to trigger it later.
        this.installPrompt = e;
    });
    }
  }
  
  </script>